"use client";

import { c as _c } from "react/compiler-runtime";
import NFTImageBalance from "@/components/nft-image/NFTImageBalance";
import NFTMediaContainer from "@/components/nft-image/NFTMediaContainer";
import styles from "@/components/nft-image/NFTImage.module.scss";
import type { BaseRendererProps } from "@/components/nft-image/types/renderer-props";
import { withArweaveFallback } from "@/components/nft-image/utils/gateway-fallback";
import Image from "next/image";
function getSrc(nft: BaseRendererProps["nft"], showThumbnail: boolean, showOriginal: boolean): string {
  if (showThumbnail) {
    return nft.thumbnail;
  }
  if (!showOriginal && nft.scaled) {
    return nft.scaled;
  }
  return nft.image;
}
function getMetadataImage(nft: BaseRendererProps["nft"]): string | undefined {
  if (!("metadata" in nft)) {
    return undefined;
  }
  const metadata: unknown = nft.metadata;
  if (metadata === null || typeof metadata !== "object") {
    return undefined;
  }
  const image = (metadata as {
    readonly image?: unknown;
  }).image;
  return typeof image === "string" ? image : undefined;
}
export default function NFTImageRenderer(props) {
  const $ = _c(26);
  const t0 = !!props.showThumbnail;
  const t1 = !!props.showOriginal;
  let t2;
  if ($[0] !== props.nft || $[1] !== t0 || $[2] !== t1) {
    t2 = getSrc(props.nft, t0, t1);
    $[0] = props.nft;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const src = t2;
  const shouldLazyLoad = !!props.showThumbnail || props.height === 300;
  const imageWrapperClassName = styles.imageWrapper ?? "";
  const t3 = props.bgStyle === "";
  const t4 = `${imageWrapperClassName} ${props.heightStyle} ${props.bgStyle}`;
  const t5 = shouldLazyLoad ? "lazy" : "eager";
  const t6 = !shouldLazyLoad;
  const t7 = shouldLazyLoad ? "auto" : "high";
  const t8 = props.imageStyle;
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      height: "auto",
      width: "auto",
      maxWidth: "100%",
      maxHeight: "100%"
    };
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  const t10 = props.id ?? `image-${props.nft.id}`;
  const t11 = props.nft.name;
  let t12;
  if ($[5] !== props.nft) {
    t12 = withArweaveFallback(t13 => {
      const {
        currentTarget
      } = t13;
      if (currentTarget.src === props.nft.thumbnail) {
        currentTarget.src = props.nft.scaled ? props.nft.scaled : props.nft.image;
      } else {
        if (currentTarget.src === props.nft.scaled) {
          currentTarget.src = props.nft.image;
        } else {
          const metadataImage = getMetadataImage(props.nft);
          if (metadataImage) {
            currentTarget.src = metadataImage;
          }
        }
      }
    });
    $[5] = props.nft;
    $[6] = t12;
  } else {
    t12 = $[6];
  }
  let t13;
  if ($[7] !== props.imageStyle || $[8] !== props.nft.name || $[9] !== src || $[10] !== t10 || $[11] !== t12 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t13 = <Image loading={t5} priority={t6} width="0" height="0" fetchPriority={t7} unoptimized={true} className={t8} style={t9} id={t10} src={src} alt={t11} onError={t12} />;
    $[7] = props.imageStyle;
    $[8] = props.nft.name;
    $[9] = src;
    $[10] = t10;
    $[11] = t12;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== props.height || $[17] !== props.nft.contract || $[18] !== props.nft.id || $[19] !== props.showBalance) {
    t14 = props.showBalance && <NFTImageBalance contract={props.nft.contract} tokenId={props.nft.id} height={props.height} />;
    $[16] = props.height;
    $[17] = props.nft.contract;
    $[18] = props.nft.id;
    $[19] = props.showBalance;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t13 || $[22] !== t14 || $[23] !== t3 || $[24] !== t4) {
    t15 = <NFTMediaContainer textCenter={true} forceIronBackground={t3} className={t4}>{t13}{t14}</NFTMediaContainer>;
    $[21] = t13;
    $[22] = t14;
    $[23] = t3;
    $[24] = t4;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  return t15;
}